import { supabase } from '../supabase/client';

/**
 * Löscht einen Mieter endgültig. Räumt zuerst die nicht-FK-gebundenen Verweise
 * (kontakt_kanaele, entity_links, Notizen und protokollierte Aktivitäten – Freigabe 13.10.2026),
 * dann die mieter-Zeile. Die Fremdschlüssel regeln den Rest: dokumente CASCADE;
 * email_analysen/emails/tickets/termine/vertraege/zaehler = ON DELETE SET NULL.
 * Das Änderungsprotokoll (entity_audit) bleibt als Nachweis erhalten.
 * Schlägt ein Schritt fehl, wird abgebrochen, bevor der Mieter selbst gelöscht ist. Wirft bei Fehler.
 */
export async function loescheMieter(mieterId: string): Promise<void> {
  const schritte = [
    () => supabase.from('kontakt_kanaele').delete().eq('owner_type', 'mieter').eq('owner_id', mieterId),
    () => supabase.from('kontakt_notizen').delete().eq('quelle', 'mieter').eq('quelle_id', mieterId),
    () => supabase.from('kontakt_aktivitaeten').delete().eq('quelle', 'mieter').eq('quelle_id', mieterId),
    () => supabase.from('entity_links').delete().eq('source_type', 'mieter').eq('source_id', mieterId),
    () => supabase.from('entity_links').delete().eq('target_type', 'mieter').eq('target_id', mieterId),
  ];
  for (const schritt of schritte) {
    const { error } = await schritt();
    if (error) throw new Error(error.message);
  }
  const { error } = await supabase.from('mieter').delete().eq('id', mieterId);
  if (error) throw new Error(error.message);
}
